import { WidgetT } from 'lib-shared-legacy-types';

import { ajaxSend } from '../../../api/api';
import type { ChatWidget } from '../reducers/sections/chatWidgets';

const basePath = '/v1/widgets';

export function createWidget(widget: Partial<WidgetT>) {
  const newWidget = { ...widget };

  delete newWidget.id;
  delete newWidget.created_at;
  delete newWidget.updated_at;
  delete newWidget.organization_id;

  return ajaxSend({
    path: basePath,
    method: 'POST',
    data: newWidget,
  });
}

export function readWidget(widgetId: string) {
  return ajaxSend({
    path: `${basePath}/${widgetId}`,
    method: 'GET',
  });
}

export function readWidgets(payload: any) {
  const { query } = payload;

  let path = query && query.path ? query.path : null;
  const limit = query && query.limit ? 'limit=' + query.limit : 'limit=20';

  if (path === null) {
    path = `${basePath}?${limit}`;
  }

  return ajaxSend({
    path: path,
    method: 'GET',
  });
}

export function updateWidget(data: any, id: string) {
  if (id === null || id === undefined) {
    throw new Error('Widget ID cannot be null');
  }

  return ajaxSend({
    path: `${basePath}/${id}`,
    method: 'PATCH',
    data: data,
  });
}

export function deleteWidget(widget: ChatWidget) {
  if (widget.id === null || widget.id === undefined) {
    throw new Error('Widget ID cannot be null');
  }

  return ajaxSend({
    path: `${basePath}/${widget.id}`,
    method: 'DELETE',
  });
}
